import CryptoJS from "crypto-js";

// 1️⃣ AES 密钥（16 字节，必须和 APP/后端一致）
const key = CryptoJS.enc.Utf8.parse("AiChat$MuYuHan#9");

/**
 * AES 解密函数（CBC + PKCS7）
 * @param encryptedText Base64 加密字符串（IV + 密文）
 * @returns 解密后的 JSON 对象或明文字符串
 */
export const aesDecrypt = (encryptedText: string) => {
  // Base64 解码
  const decoded = CryptoJS.enc.Base64.parse(encryptedText)
  const decodedWords = decoded.words
  const decodedSigBytes = decoded.sigBytes

  if (decodedSigBytes < 16) {
    throw new Error('ciphertext too short')
  }

  // 提取 IV（前 16 字节 = 4 个 word）
  const iv = CryptoJS.lib.WordArray.create(decodedWords.slice(0, 4), 16)
  // 提取密文（余下部分）
  const ciphertext = CryptoJS.lib.WordArray.create(decodedWords.slice(4), decodedSigBytes - 16)

  // AES-CBC 解密 + PKCS7 填充
  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  const plain = CryptoJS.enc.Utf8.stringify(decrypted)
  if (!plain) throw new Error('Malformed UTF-8 data')

  try {
    return JSON.parse(plain)
  } catch {
    return plain
  }
}

